var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"as-radio",class:_vm.value ? 'selected' : '',on:{"click":_vm.onClick}},[_c('div',{staticClass:"as-radio__label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"as-radio__button"})])}
var staticRenderFns = []

export { render, staticRenderFns }